<template>
  <b-jumbotron v-if="grammars.length" :header="header" header-level="5">
    <div class="p-3" v-for="grammar in grammars" :key="grammar.grammarId">
      <b-badge variant="secondary">Point {{ grammar.number }}</b-badge>
      <div class="my-4">
        <b-button
          variant="outline-secondary"
          v-b-tooltip.hover.right
          v-b-modal="`modal-${grammar.grammarId}`"
          :title="tooltipForGrammar"
        >
          {{ grammar.title }}
        </b-button>
      </div>
      <b-modal
        :id="`modal-${grammar.grammarId}`"
        scrollable
        :title="grammar.title"
        ok-only
        ok-variant="primary"
        ok-title="Close"
        size="xl"
        header-text-variant="dark"
        header-bg-variant="light"
      >
        <p v-html="grammar.content"></p>
      </b-modal>
    </div>
  </b-jumbotron>
</template>

<script>
  export default {
    name: "GrammarView",
    data() {
      return {
        header: 'Grammar points',
        tooltipForGrammar: process.env.VUE_APP_GRAMMAR_TOOLTIP,
      };
    },
    props: {
      grammars: {
        type: Array,
        default: () => []
      }
    }
  }
</script>

<style scoped>

</style>

